'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _resources = require('redux/modules/resources');

var _reactRouter = require('react-router');

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YES = 'Yes';
var NO = 'No';

var Module4App5 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module4,
    app: state.moduleData.data.module4.app5,
    profile: state.profile.data,
    module: state.resources.module,
    item: state.resources.item
  };
}, (0, _extends3.default)({}, moduleActions, { changeResource: _resources.changeResource, changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module4App5, _Component);

  function Module4App5() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module4App5);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module4App5.__proto__ || (0, _getPrototypeOf2.default)(Module4App5)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 4,
      appId: 5,
      module: 'Module 3',
      title: 'Review Modules 1 - 3',
      isCompleted: _this.props.app.isCompleted || false,
      rememberFVNeeds: _this.props.app.rememberFVNeeds || '', // do you remember how many serves of fruit and vegetables your child needs each day
      discoverDiet: _this.props.app.discoverDiet || '', // what have you discevered by comparing your child's diet to the recommendations?
      understandServes: _this.props.app.understandServes || '', // do you feel you have a better understanding of serves?
      recap: _this.props.app.recap || '', // would you like a recap about fruit and vegetable serves
      offeringMoreVege: _this.props.app.offeringMoreVege || '', // do you feel like you've been offering more vege serves
      lackOfTime: _this.props.app.lackOfTime || '', // Many parents find a lack of time to prepare healthy meals for their child a barrier.
      // Is this a likely and difficult situation for you?
      prepareMeals: _this.props.app.prepareMeals || '', // Many parents struggle to keep their child occupied while they prepare meals. Is this a difficulty for you?
      avoidSituation: _this.props.app.avoidSituation || '', // Can you think of anything you could do to either make this situation easier or avoid this situation altogether?
      isSituationExist: _this.props.app.isSituationExist || '' // Is there a suggestion here that you think could work for you?
    }, _this.convertISOTimeToAge = function () {
      var now = new Date();
      var date = new Date(_this.props.profile.childDOB);
      var yearDiff = now.getFullYear() - date.getFullYear();
      var monthDiff = now.getMonth() - date.getMonth();
      var dayDiff = now.getDay() - date.getDay();

      if (monthDiff < 0) {
        yearDiff--;
      } else if (monthDiff === 0) {
        if (dayDiff < 0) {
          yearDiff--;
        }
      }
      return yearDiff;
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      // this.props.updateModule(this.props.user.userId, this.state.moduleId, {
      //   'numAppCompleted': numAppCompleted,
      //   'numAppTotal': this.props.allModule.numAppTotal});

      // this.props.changeItem(this.state.moduleId, 0, this.state.appId + 1);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleResourceClick = function (module, item, event) {
      console.log(event);
      _this.props.changeResource(module, item, 0);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /* Convert the child date of birth to an age */


  /*
   * Handle when user finishes this module
   */


  /*
   * User types in something for what was
   * involved in the diet
   */


  // used to navigate to a resource item


  (0, _createClass3.default)(Module4App5, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');
      var serveImg = require('../Assets/vegeserve.png');
      var age = this.convertISOTimeToAge();

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              this.state.module
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12, sm: 12, xs: 12 },
              _react2.default.createElement(
                'p',
                null,
                'We are now going to review the topics we\'ve covered in the last 3 modules. A summary of these can be found under the module resources in the resources tab.'
              ),
              _react2.default.createElement(
                'h3',
                null,
                'Serves of fruit and vegetables'
              ),
              _react2.default.createElement(
                'p',
                null,
                'In the first module we talked about recommended number of fruit and vegetable servings.'
              ),
              _react2.default.createElement(
                'h5',
                null,
                'Do you remember how many serves of fruit and vegetables your child needs each day?'
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                { onChange: this.handleChange.bind(this, 'rememberFVNeeds') },
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'rememberFVNeeds', value: YES, checked: this.state.rememberFVNeeds === YES || this.state.rememberFVNeeds == 1 },
                  YES
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'rememberFVNeeds', value: NO, checked: this.state.rememberFVNeeds === NO || this.state.rememberFVNeeds == 0 },
                  NO
                )
              ),
              (this.state.rememberFVNeeds === NO || this.state.rememberFVNeeds == 0) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'Remember that ',
                  this.props.profile.childName,
                  ' needs the following amount of serves:'
                ),
                _react2.default.createElement(_components.FoodTable, { foodtitle: 'vegetables', foodtype: 'Vegetables', twoyear: '2 1/2', fouryearboy: '4 1/2', fouryeargirl: '4 1/2',
                  nineyearboy: '5 1/2', nineyeargirl: '5', twelveyearboy: '5 1/2', twelveyeargirl: '5' }),
                _react2.default.createElement('div', { className: styles.spacer20 }),
                _react2.default.createElement(_components.FoodTable, { foodtitle: 'fruit', foodtype: 'Fruit', twoyear: '1', fouryearboy: '1 1/2', fouryeargirl: '1 1/2',
                  nineyearboy: ' 2', nineyeargirl: '2', twelveyearboy: '2', twelveyeargirl: '2' })
              ),
              this.state.rememberFVNeeds && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  'What have you discovered by comparing your child\'s diet to the recommendations?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleChange.bind(this, 'discoverDiet') },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'discoverDiet', value: 'Something', checked: this.state.discoverDiet === 'Something' },
                    'Something'
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'discoverDiet', value: 'Nothing', checked: this.state.discoverDiet === 'Nothing' },
                    'Nothing'
                  )
                )
              ),
              this.state.discoverDiet && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'It\'s great that you\'ve been able to take a close look at the foods ',
                  this.props.profile.childName,
                  ' is eating in relation to the Australian Guidelines.'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'h5',
                  null,
                  'Do you feel you have a better understanding of serves?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleChange.bind(this, 'understandServes') },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'understandServes', value: YES, checked: this.state.understandServes === YES || this.state.understandServes == 1 },
                    YES
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'understandServes', value: NO, checked: this.state.understandServes === NO || this.state.understandServes == 0 },
                    NO
                  )
                )
              ),
              (this.state.understandServes || this.state.understandServes == 0) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  'Would you like a recap about fruit and vegetable serves?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleChange.bind(this, 'recap') },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'recap', value: YES, checked: this.state.recap === YES || this.state.recap == 1 },
                    YES
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'recap', value: NO, checked: this.state.recap === NO || this.state.recap == 0 },
                    NO
                  )
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.Row,
                null,
                (this.state.recap === YES || this.state.recap == 1) && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { md: 4, sm: 12, xs: 4, lg: 4 },
                    _react2.default.createElement(ReactBootstrap.Image, { src: serveImg, className: styles.img60, responsive: true })
                  )
                ),
                (this.state.recap === YES || this.state.recap == 1) && age < 3 && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { md: 8, sm: 12, xs: 8, lg: 8 },
                    _react2.default.createElement(
                      'h4',
                      null,
                      'Vegetables'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      this.props.profile.childName,
                      ' should have 2.5 serves of vegetables each day.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'An example of this would be: carrot sticks for morning tea, and for dinner, a piece of pumpkin or 1/2 medium potato and half a cup/pile of frozen peas and corn.'
                    ),
                    _react2.default.createElement(
                      'h4',
                      null,
                      'Fruit'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      this.props.profile.childName,
                      ' should have 1 serve of fruit each day. Eg. banana.'
                    )
                  )
                ),
                (this.state.recap === YES || this.state.recap == 1) && age > 3 && age < 9 && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { md: 8, sm: 12, xs: 8, lg: 8 },
                    _react2.default.createElement(
                      'h4',
                      null,
                      'Vegetables'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      this.props.profile.childName,
                      ' should have 4.5 serves of vegetables each day.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'An example of this would be: a salad sandwich at lunch, and for dinner some pumpkin and potato and a pile of frozen peas, carrots and corn.'
                    ),
                    _react2.default.createElement(
                      'h4',
                      null,
                      'Fruit'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      this.props.profile.childName,
                      ' should have 1.5 serves of fruit each day. Eg. a banana and a small kiwi fruit.'
                    )
                  )
                ),
                (this.state.recap === YES || this.state.recap == 1) && age > 8 && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { md: 8, sm: 12, xs: 8, lg: 8 },
                    _react2.default.createElement(
                      'h4',
                      null,
                      'Vegetables'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      this.props.profile.childName,
                      ' should have 5 serves of vegetables each day.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'An example of this would be: carrot sticks at morning tea, a salad sandwich at lunch, and for dinner some pumpkin and potato and a pile of frozen peas, carrots and corn.'
                    ),
                    _react2.default.createElement(
                      'h4',
                      null,
                      'Fruit'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      this.props.profile.childName,
                      ' should have 2 serves of fruit each day. Eg. a banana, a small kiwi fruit and 1/2 cup of chopped pears in natural juice.'
                    )
                  )
                )
              ),
              (this.state.recap || this.state.recap == 0) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h3',
                  null,
                  'Providing fruit and vegetables to children'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'We also talked about ways to ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'increase opportunities for ',
                    this.props.profile.childName,
                    ' to consume fruit and vegetables over the day. '
                  ),
                  _react2.default.createElement('br', null),
                  'For example, we talked about:'
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Providing ',
                      _react2.default.createElement(
                        'strong',
                        { className: styles.orangeText },
                        'vegetables as snacks'
                      ),
                      ', as well as in ',
                      _react2.default.createElement(
                        'strong',
                        { className: styles.orangeText },
                        'sandwiches and in main meals'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'We suggested adding ',
                      _react2.default.createElement(
                        'strong',
                        { className: styles.orangeText },
                        'fruit to breakfast, dessert, and lunches'
                      ),
                      ', and of course, as a ',
                      _react2.default.createElement(
                        'strong',
                        { className: styles.orangeText },
                        'snack'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Since we went through these things, do you feel like you\'ve been offering more vegies?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleChange.bind(this, 'offeringMoreVege') },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'offeringMoreVege', value: YES, checked: this.state.offeringMoreVege === YES || this.state.offeringMoreVege == 1 },
                    YES
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'offeringMoreVege', value: NO, checked: this.state.offeringMoreVege === NO || this.state.offeringMoreVege == 0 },
                    NO
                  )
                )
              ),
              (this.state.offeringMoreVege || this.state.offeringMoreVege == 0) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h3',
                  null,
                  'Chopping up vegetables'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'In module 2, we suggested that you routinely chop up vegetables so that they are ready to eat ahead of time. This is a great way of planning ahead and having healthy ready snacks available. Keep it up!'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'If you haven\'t yet tried it during the Reboot program, think about giving it a try. You can always provide snack packs of fruit in natural juice and some greengrocers/fruit shops sell ready cut vegetables to go!'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'HELPS guide'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'In module 2, you learnt about the HELPS framework that helps us look at the eating environment.'
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      _react2.default.createElement(
                        'strong',
                        { className: styles.orangeText },
                        'Hungry:'
                      ),
                      ' Encourage children to eat only when they are hungry'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      _react2.default.createElement(
                        'strong',
                        { className: styles.orangeText },
                        'Eating:'
                      ),
                      ' and nothing else. TV and screens off'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      _react2.default.createElement(
                        'strong',
                        { className: styles.orangeText },
                        'Location:'
                      ),
                      ' A place designed for eating'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      _react2.default.createElement(
                        'strong',
                        { className: styles.orangeText },
                        'Plate:'
                      ),
                      ' Eating from a plate helps to learn how much to eat'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      _react2.default.createElement(
                        'strong',
                        { className: styles.orangeText },
                        'Sitting:'
                      ),
                      ' Sit down to eat'
                    )
                  )
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Healthy eating habits'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'We spoke about how the eating environment affects our eating habits so it\'s important to include planning to:'
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Eat ',
                      _react2.default.createElement(
                        'strong',
                        { className: styles.orangeText },
                        'regular'
                      ),
                      ' meals and snacks'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Eat ',
                      _react2.default.createElement(
                        'strong',
                        { className: styles.orangeText },
                        'together'
                      ),
                      ' with the family'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Eat in an ',
                      _react2.default.createElement(
                        'strong',
                        { className: styles.orangeText },
                        'eating location'
                      ),
                      ' (eg. table)'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Eat ',
                      _react2.default.createElement(
                        'strong',
                        { className: styles.orangeText },
                        'without the television on'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Meal planning'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'We provided you with a meal planner and talked about the ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'benefits of planning meals and snacks ahead of time '
                  ),
                  'ie. it can save you time, money and stress when trying to ensure there is a variety of fruit and vegetables in the house.'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'P\'s and C\'s'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'In module 3 you were introduced to the P\'s and C\'s framework, the framework suggests that it is the parent\'s responsibility to provide the food but that is where the job stops and it\'s the child\'s decision whether, when and how much to eat.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Remember that is is just one way to think about the parent-child feeding relationship. Some parents like it as it acknowledges that there\'s only so much they can do as the parent.'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Role modelling'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'We also talked about setting an example to ',
                  this.props.profile.childName,
                  ' by eating lots of fruit and vegetables, having healthy habits, and a positive attitude towards healthy foods.'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Planning ahead'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'We are now going to talk about planning ahead for difficult situations.',
                  _react2.default.createElement('br', null),
                  'Let\'s run through a few situations where other parents find it difficult to support healthy eating.'
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  'Situation 1'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The first situation is grocery shopping with your child. This can make shopping more stressful and often kids want you to buy \'sometimes\' foods. Is this a likely and difficult situation for you?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleChange.bind(this, 'situation1') },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'situation1', value: YES, checked: this.state.situation1 === YES },
                    YES
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'situation1', value: NO, checked: this.state.situation1 === NO },
                    NO
                  )
                )
              ),
              this.state.situation1 === NO && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'That\'s great!'
                )
              ),
              this.state.situation1 === YES && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Can you think of anything you could do to make this situation easier?'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'One option is to explain to your child that you have a shopping list and can only buy things off the list. Set clear rules, explain the rules, and stick to them. ',
                      _react2.default.createElement(
                        _reactRouter.Link,
                        { to: '/resourceslanding', onClick: this.handleResourceClick.bind(this, 4, 1) },
                        'Click here '
                      ),
                      ' for more ideas, such as encouraging your child to be involved in the shopping and taking toys along'
                    )
                  )
                )
              ),
              this.state.situation1 && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h4',
                  null,
                  'Situation 2'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Many parents find a lack of time to prepare healthy meals for their child a barrier. Is this a likely and difficult situation for you?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleChange.bind(this, 'lackOfTime') },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'lackOfTime', value: YES, checked: this.state.lackOfTime === YES },
                    YES
                  ),
                  this.state.lackOfTime === YES && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(
                          'span',
                          null,
                          'What are the sorts of things that you could do to try to manage these busy times?'
                        )
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(
                          'span',
                          null,
                          'Being prepared can be a big help'
                        )
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(
                          'span',
                          null,
                          'Some parents suggest: planning meals ahead of time, making bigger meals and freezing the left-overs, and setting aside time to prepare meals and snacks'
                        )
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(
                          'span',
                          null,
                          'It\'s also good if you can have a few quick and easy recipes under your belt and some quick and healthy food supplies for when time is limited. A can of baked beans and some frozen bread will often get you out of a tight spot'
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'lackOfTime', value: NO, checked: this.state.lackOfTime === NO },
                    NO
                  )
                )
              ),
              this.state.lackOfTime === NO && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'That\'s great!'
                )
              ),
              this.state.lackOfTime && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h4',
                  null,
                  'Situation 3'
                ),
                _react2.default.createElement(
                  'h5',
                  null,
                  'Many parents struggle to keep their child occupied while they prepare meals. Is this a difficulty for you?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleChange.bind(this, 'prepareMeals') },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'prepareMeals', value: YES, checked: this.state.prepareMeals === YES },
                    YES
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'prepareMeals', value: NO, checked: this.state.prepareMeals === NO },
                    NO
                  )
                ),
                this.state.prepareMeals === YES && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'p',
                    null,
                    'Can you think of anything you could do to either make this situation easier or avoid this situation altogether?'
                  ),
                  _react2.default.createElement(ReactBootstrap.FormControl, { componentClass: 'textarea', placeholder: 'Strategies to make this situation easier...',
                    onChange: this.handleChange.bind(this, 'avoidSituation') }),
                  _react2.default.createElement('br', null)
                )
              ),
              this.state.prepareMeals === NO && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'That\'s great!'
                )
              ),
              this.state.avoidSituation && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'We\'ve already talked about getting your child to help with meal preparation, which is one option.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Alternatively, quiet activities like colouring-in can help to keep kids occupied, while you\'re preparing food.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'And of course, make the most of any opportunities when someone else is caring for your child to make meals in advance.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Is there a suggestion here that you think could work for you?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleChange.bind(this, 'isSituationExist') },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'isSituationExist', value: YES, checked: this.state.isSituationExist === YES },
                    YES
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'isSituationExist', value: NO, checked: this.state.isSituationExist === NO },
                    NO
                  )
                )
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
          )
        )
      );
    }
  }]);
  return Module4App5;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  profile: _propTypes2.default.object,
  module: _propTypes2.default.number,
  item: _propTypes2.default.number,
  changeResource: _propTypes2.default.func.isRequired,
  changeItem: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
exports.default = Module4App5;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/4/App/App5.js
// module id = 1210
// module chunks = 0